import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { customStylesBlue } from 'components/customReactSelectStyles'
import countries from '../countries.csv'
import cantons from '../cantons.csv'
import { formatFortune } from '../misc.js'
import sectors from '../../../static/sectors.json'
import './styles.scss'

interface ProfilesMenuProps {
  data: ProfileData[]
  handleChange: (value: ProfileData[]) => void
  isOpen: boolean
}

export const ProfilesMenu = ({
  data,
  handleChange,
  isOpen
}: ProfilesMenuProps) => {
  const [filteredData, setFilteredData] = useState(data)
  const [filterNameValue, setFilterNameValue] = useState(null)
  const [filters, setFilters] = useState({
    name: '',
    residence: null,
    evolution: null,
    sector: null,
    fortune: null
  })

  console.log('render')

  const residenceFilterOptions = React.useMemo(() => {
    const options = new Set()
    filteredData.forEach(profile => {
      profile.residence.forEach(residence => {
        options.add(residence.value)
      })
    })
    return [...options.values()]
  }, [filteredData])

  const fortuneFilterOptions = React.useMemo(() => {
    return [
      { value: {min: 20, max: 24}, label: '20 à 25 ans' },
      { value: {min: 25, max: 29}, label: '25 à 30 ans' },
      { value: {min: 30, max: 34}, label: '30 à 35 ans' },
      { value: {min: 35, max: 39}, label: '35 à 40 ans' }
    ]
  }, [filteredData])

  const sectorFilterOptions = React.useMemo(() => {
    const options = new Set()
    filteredData.forEach(profile => {
      profile.sectors.forEach(sector => {
        options.add(sector.id)
      })
    })
    return [...options.values()]
  }, [filteredData])

  const marketFilterOptions = React.useMemo(() => {
    const options = new Set()
    filteredData.forEach(profile => {
      profile.markets.forEach(sector => {
        options.add(sector.id)
      })
    })
    return [...options.values()]
  }, [filteredData])

  const evolutionFilterOptions = React.useMemo(() => {
    const labels = {
      up: 'En hausse',
      down: 'En baisse',
      flat: 'Stable',
      new: 'Nouveau'
    }
    const options = new Set()
    filteredData.forEach(profile => {
      options.add(profile.fortuneEvolution)
    })
    console.log([...options.values()])
    return [...options.values()].map(o => ({ label: labels[o], value: o }))
  }, [filteredData])

  const handleNameFilterChange = (value: string | null) => {
    setFilters({ ...filters, name: value })
  }

  const handleResidenceFilterChange = (value: string | null) => {
    setFilters({ ...filters, residence: value })
  }

  const handleFortuneFilterChange = (value: string | null) => {
    setFilters({ ...filters, fortune: value })
  }

  const handleSectorFilterChange = (value: string | null) => {
    setFilters({ ...filters, sector: value })
  }

  const handleEvolutionFilterChange = (value: string | null) => {
    setFilters({ ...filters, evolution: value })
  }

  const applyFilters = () => {
    const nameFilter = data.filter(d =>
      (d.firstname + ' ' + d.surname)
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .includes(
          filters.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
        ) || d.businessName
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .includes(
          filters.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
        )
    )

    const residenceFilter = filters.residence
      ? nameFilter.filter(d =>
          d.residence.map(r => r.value).includes(filters.residence)
        )
      : nameFilter

    const fortuneFilter = filters.fortune
      ? residenceFilter.filter(
          r => {
            const a = parseInt(r.age.trim().slice(0,2))
            console.log(a, a < 24)
            return a >= filters.fortune.min && a <= filters.fortune.max
          }
            )
      : residenceFilter

    const sectorFilter = filters.sector
      ? fortuneFilter.filter(d =>
          d.sectors.map(s => s.id).includes(filters.sector)
        )
      : fortuneFilter

    const evolutionFilter = filters.evolution
      ? sectorFilter.filter(d =>
        d.markets.map(s => s.id).includes(filters.evolution)
      )
      : sectorFilter

    setFilteredData(evolutionFilter)
  }

  useEffect(() => {
    handleChange(filteredData)
  }, [filteredData])

  useEffect(() => {
    console.log(filters)
    applyFilters()
  }, [filters])

  return (
    <div className={`profiles-menu ${isOpen ? 'open' : ''}`}>
      {/* <div className='small-title filters-label'>Le classement</div> */}

      <div className='banner ui'>
        <div className='ui container center aligned'>
          <div>
            <div className='ui search'>
              <div className='ui icon input'>
                <input
                  className='prompt'
                  type='text'
                  placeholder='Chercher...'
                  value={filterNameValue || undefined}
                  onChange={e => {
                    handleNameFilterChange(e.target.value || '')
                  }}
                />
                <i className='search icon' />
              </div>
              {!isOpen && (
                <div
                  style={{ marginLeft: '1em' }}
                  className='profile-link-button'
                  onClick={() => {
                    window.scroll({
                      top:
                        document
                          .getElementById('profiles-list')
                          .getBoundingClientRect().top +
                        window.scrollY -
                        100,
                      behavior: 'smooth'
                    })
                  }}
                >
                  Voir les filtres
                </div>
              )}
            </div>
          </div>
          <form className='ui form filters'>
            <div className='field'>
              <div className='ui two columns grid'>
                <div className='column'>
                  <div className='ui two columns stackable grid'>
                    <div className='column'>
                      <Select
                        placeholder='Résidence'
                        menuPortalTarget={document.body}
                        styles={customStylesBlue}
                        isClearable
                        name='residence-filter'
                        noOptionsMessage={() => 'Pas de résultat'}
                        onChange={value => {
                          const residence = value ? value.value : null
                          handleResidenceFilterChange(residence || null)
                        }}
                        options={[
                          {
                            label: 'Suisse',
                            options: cantons
                              .filter(o =>
                                residenceFilterOptions.includes(o.alpha2)
                              )
                              .reduce(
                                (a, b) => [
                                  { value: b.alpha2, label: b.name },
                                  ...a
                                ],
                                []
                              )
                          },
                          {
                            label: 'Monde',
                            options: countries
                              .filter(o =>
                                residenceFilterOptions.includes(o.alpha2)
                              )
                              .reduce(
                                (a, b) => [
                                  { value: b.alpha2, label: b.name },
                                  ...a
                                ],
                                []
                              )
                          }
                        ]}
                        className='basic-multi-select'
                        classNamePrefix='select'
                      />
                    </div>
                    <div className='column'>
                      <Select
                        isClearable
                        menuPortalTarget={document.body}
                        styles={customStylesBlue}
                        placeholder='Âge'
                        noOptionsMessage={() => 'Pas de résultat'}
                        name='sectors-filter'
                        onChange={value => {
                          const fortuneGroup = value ? value.value : null
                          handleFortuneFilterChange(fortuneGroup || null)
                        }}
                        options={fortuneFilterOptions}
                        className='basic-multi-select'
                        classNamePrefix='select'
                      />
                    </div>
                  </div>
                </div>
                <div className='column'>
                  <div className='ui two columns stackable grid'>
                    <div className='column'>
                      <Select
                        isClearable
                        menuPortalTarget={document.body}
                        styles={customStylesBlue}
                        placeholder='Secteur(s)'
                        noOptionsMessage={() => 'Pas de résultat'}
                        name='sectors-filter'
                        onChange={value => {
                          const sector = value ? value.value : null
                          handleSectorFilterChange(sector || null)
                        }}
                        options={sectors
                          .filter(sector =>
                            sectorFilterOptions.includes(sector.id)
                          )
                          .reduce(
                            (a, b) => [{ value: b.id, label: b.name }, ...a],
                            []
                          )}
                        className='basic-multi-select'
                        classNamePrefix='select'
                      />
                    </div>
                    <div className='column'>
                      <Select
                        isClearable
                        menuPortalTarget={document.body}
                        styles={customStylesBlue}
                        placeholder='Marché(s)'
                        noOptionsMessage={() => 'Pas de résultat'}
                        name='sectors-filter'
                        onChange={value => {
                          const evolution = value ? value.value : null
                          handleEvolutionFilterChange(evolution || null)
                        }}
                        options={sectors
                          .filter(sector =>
                            marketFilterOptions.includes(sector.id)
                          )
                          .reduce(
                            (a, b) => [{ value: b.id, label: b.name }, ...a],
                            []
                          )}
                        className='basic-multi-select'
                        classNamePrefix='select'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='ui blue vertical segment filters-result-label'>
          <div className='ui text container center aligned'>
            <div className='small-title'>
              {filteredData.length} résultat{data.length > 1 ? 's' : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
